// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-automated[data-v-cbafbb84]{font-size:1.25rem;height:1.5rem}.automated-translation-label[data-v-cbafbb84]{color:#767676;font-size:1rem;line-height:1.5}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
